controllers.controller('PersonalProfileController', [
    '$window', '$scope', '$state', '$ionicLoading', '$q', '$timeout', '$ionicModal', '$ionicPopup', 'ionicToast',
    'config', 'constants', 'ErrorService', 'LocaleService', 'LoginService', 'API', 'Utils', 'LocalStorage',
    'Storage', 'Validator', 'UserService', 'AccountService', 'ServerTimeService', 'moment', 'CountryService', 'ProfileRulesHelper',
    'Onesignal',
    function ($window, $scope, $state, $ionicLoading, $q, $timeout, $ionicModal, $ionicPopup, ionicToast,
              config, Const, ErrorService, LocaleService, LoginService, API, Utils, LocalStorage,
              Storage, Validator, UserService, AccountService, ServerTimeService, moment, CountryService, ProfileRulesHelper,
              Onesignal) {

        log('personal profile controller');

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
            $scope.lang = LocaleService.lang;
        });

        $scope.user = UserService.get();
        $scope.currencyList = Storage.get('currencies') || [];
        $scope.constants = Const;
        $scope.useDemoAccounts = Storage.get('useDemo');
        $scope.pageState = 0;
        $scope.profileRulesHelper = new ProfileRulesHelper(Const['profileFieldRules'], 'registration');

        /*
        Filter blocked for registration countries after preparing citizenship collection
         */
        $scope.countries = Const['profileAllCountries']
            ? CountryService.get()
            : CountryService.getAllowedCountries();

        $scope.citizenships = CountryService.getCitizenships();
        $scope.taxCountries = CountryService.get();

        $scope.editSensitiveDetails = Utils.toBoolean(Storage.get('editSensitiveDetails'));
        $scope.currencyList = getAllowedCurrencies($scope.user.country);

        $scope.isRegulated = Storage.get('regulated');

        $scope.isPromo = true;
        $scope.minBirth = moment().utc().subtract(18, 'y').format("YYYY-MM-DD");

        $scope.defaultProfileForm = {
            firstName: $scope.user.firstName || '',
            lastName: $scope.user.lastName || '',
            birthday: '',
            country: _.find($scope.countries, {code: $scope.user.country}) || {country: ''},
            state: {stateName: ''},
            citizenship: {citizenship: ''},
            currency: setCurrency(),
            city: '',
            address: '',
            postCode: '',
            phone: $scope.user.phone,
            usCitizen: null,
            usTaxId: '',
            customerType: '',
            terms: false
        };

        if ($scope.isRegulated) {
            $scope.defaultProfileForm.tin = null;
            $scope.defaultProfileForm.taxCountry = {country: ''};
            $scope.defaultProfileForm.nationalId = null;
            $scope.defaultProfileForm.companyName = null;

            $scope.defaultProfileForm.isMarried = null;
            $scope.defaultProfileForm.isSpouse = null;
            $scope.defaultProfileForm.birthPlace = null;
            $scope.defaultProfileForm.pep = null;
            $scope.defaultProfileForm.tinAbsenseReason = null;
        }

        $scope.personalProfileForm = {
            customFields: null
        };

        $scope.autoUpdatePersonalDetails = Const['autoUpdatePersonalDetails'] && $scope.user.registrationState < Const.userState.questionnaire;
        $scope.allFieldsAreRequired = !Const['autoUpdatePersonalDetails'];

        function getAllowedCurrencies(userCountryCode) {
            var userCountry = CountryService.countries.get({code: userCountryCode});
            var allowedCurrencies = userCountry && userCountry.allowedCurrencies
                && userCountry.allowedCurrencies.length && userCountry.allowedCurrencies;

            var currencies = [];
            if (allowedCurrencies && allowedCurrencies.length) {
                currencies = (Storage.get('currencies') || []).filter(function (currency) {
                    return allowedCurrencies.indexOf(currency.currency) !== -1;
                });
            }
            if (!currencies.length && userCountry) {
                currencies = (Storage.get('currencies') || []).filter(function (currency) {
                    return currency.currency === userCountry.currency;
                });
            }

            return currencies;
        }

        function setCurrency(countryCode) {
            var currency = _.find($scope.currencyList, {currency: Utils.getCurrencyByCountry(countryCode || $scope.user.country, $scope.countries, $scope.currencyList)});
            return currency || '';
        }

        $scope.defaultProfileForm.state = _.find($scope.defaultProfileForm.country.states, {stateCode: $scope.user.state});
        $scope.personalProfileForm = angular.copy($scope.defaultProfileForm);

        $scope.countryStates = $scope.personalProfileForm.country.states || [];

        $scope.countryName = $scope.defaultProfileForm.country && $scope.personalProfileForm.country.country;
        $scope.taxCountryName = $scope.defaultProfileForm.taxCountry && $scope.personalProfileForm.taxCountry.country;
        $scope.stateName = $scope.defaultProfileForm.state && $scope.defaultProfileForm.state.stateName;
        $scope.validator = Validator.getPattern;
        $scope.customerTypes = Storage.get('customerTypes') || [];

        $scope.customerTypes = $scope.customerTypes.map(function (type) {
            type.label = LocaleService.translation[type.name] || type.name;
            return type
        })

        var birthPlace = _.find(CountryService.get(), {code: $scope.user.country});
        $scope.personalProfileForm.birthPlace = (birthPlace && birthPlace.country) || '';

        var defaultCustomerType = _.find($scope.customerTypes, {selected: 1});
        if (defaultCustomerType) {
            $scope.personalProfileForm.customerType = defaultCustomerType;
        }

        $scope.personalProfileForm.currency = $scope.defaultProfileForm.currency;
        $scope.personalProfileForm.terms = $scope.user.tnc;

        $scope.navigate = function (state, params) {
            $state.go(state, params);
        };

        if ($scope.autoUpdatePersonalDetails) {
            submitPersonalDetails();
        }

        $scope.modal = {
            actionText: LocaleService.translation.try_again,
            state: false,
            isProcess: false
        };

        $scope.countryModalConfig = {
            label: 'country',
            id: 'country',
            titleLabel: 'select_country',
            flagLabel: 'code'
        };

        $scope.taxCountryModal = false;

        $scope.openTaxCountryModal = function () {
            $scope.taxCountryModal = true;
        };

        $scope.setTaxCountry = function (country) {

            $scope.taxCountryModal = false;
            $scope.personalProfileForm.taxCountry = country;

            //open popup for us citizen
            if (country.code === 'US') {
                var popupTimeout = $timeout(function () {
                    $scope.showUsCitizenPopup();
                    $timeout.cancel(popupTimeout);
                }, 500);
            }
        };

        $scope.countryModal = false;

        $scope.openCountryModal = function () {
            $scope.countryModal = true;
        };

        $scope.setCountry = function (country) {
            $scope.countryModal = false;
            $scope.personalProfileForm.country = country;
            if (country.states.length > 0) {
                $scope.countryStates = country.states;
                //set first state
                $scope.personalProfileForm.state = country.states[0];
            }

            //update currency on country change
            $scope.currencyList = getAllowedCurrencies($scope.personalProfileForm.country.code);
            $scope.personalProfileForm.currency = setCurrency($scope.personalProfileForm.country.code);
        };

        $scope.countryStateModalConfig = {
            label: 'stateName',
            id: 'stateCode',
            titleLabel: 'select_state'
        };
        $scope.countryStateModal = false;
        $scope.openCountryStateModal = function () {
            $scope.countryStateModal = true;
        };

        $scope.setCountryState = function (state) {
            $scope.countryStateModal = false;
            $scope.personalProfileForm.state = state;
        };

        $scope.citizenshipModalConfig = {
            label: 'citizenship',
            id: 'citizenship',
            titleLabel: 'select_citizenship'
        };
        $scope.citizenshipModal = false;
        $scope.openCitizenshipModal = function () {
            $scope.citizenshipModal = true;
        };

        $scope.setCitizenship = function (country) {
            $scope.citizenshipModal = false;
            $scope.personalProfileForm.citizenship = country;
        };

        $scope.closeModal = function () {
            $scope.countryModal = false;
            $scope.countryStateModal = false;
            $scope.citizenshipModal = false;
            $scope.taxCountryModal = false;
        };


        $scope.showUsCitizenPopup = function () {
            var myPopup = $ionicPopup.show({
                template: $scope.translation.usCitizenPopupBody,
                title: '<span class="roboto">' + LocaleService.translation.usCitizenPopupTitle + '</span>',
                scope: $scope,
                buttons: [
                    {
                        text: LocaleService.translation.no,
                        type: 'button-full',
                        onTap: function (e) {
                            e.preventDefault();
                            console.log('reset country and citizen');
                            $scope.resetUsCitizen();
                            myPopup.close();
                        }
                    },
                    {
                        text: LocaleService.translation.yes,
                        type: 'button-full',
                        onTap: function (e) {
                            e.preventDefault();
                            myPopup.close();
                            $ionicLoading.show();
                            return submitPersonalDetails()
                                .catch(function (error) {
                                    if (error.code == "3040") {
                                        return LoginService.logout()
                                            .then(function () {
                                                $ionicLoading.hide();
                                                return $state.go('welcome', {cache: false});
                                            })
                                    }

                                    throw error;
                                })
                        }
                    }
                ]
            });
        };

        $scope.resetUsCitizen = function () {
            $scope.taxCountryName = '';
            $scope.personalProfileForm.taxCountry = null;
            $scope.personalProfileForm.usCitizen = null;
        };

        function checkResponse(data) {
            if (data.status !== 1) {
                throw new ErrorService({
                    source: 'PersonalProfileController',
                    type: Const.error.type.VALIDATION,
                    code: data.code.toString() || 'updateCustomerFailed',
                    severity: 'warning',
                    data: {response: data}
                });
            }
            return data;
        }


        function submitPersonalDetails() {

            var request = {
                firstName: $scope.personalProfileForm.firstName,
                lastName: $scope.personalProfileForm.lastName,
                birthday: $scope.allFieldsAreRequired && moment($scope.personalProfileForm.birthday).format("YYYY-MM-DD") || '',
                country: $scope.personalProfileForm.country.code,
                state: ($scope.personalProfileForm.state && $scope.personalProfileForm.state.stateCode) || '',
                city: $scope.personalProfileForm.city || '',
                address: $scope.personalProfileForm.address || '',
                currency: $scope.personalProfileForm.currency.currency,
                postCode: $scope.personalProfileForm.postCode || '',
                phone: $scope.personalProfileForm.phone,
                citizenship: $scope.personalProfileForm.citizenship.citizenship || '',
                usCitizen: 0,
                usTaxId: '',
                customerType: ($scope.personalProfileForm.customerType && $scope.personalProfileForm.customerType.name) || '',

            };

            // TODO check behaviour
            // if (!request.citizenship && !$scope.allFieldsAreRequired) {
            //     request.citizenship = ($scope.citizenships.find(function (citizenship) {
            //         return citizenship.code === request.country
            //     }) || {}).citizenship;
            // }

            if ($scope.isRegulated) {
                request.tin = $scope.personalProfileForm.tin;
                request.usCitizen = Utils.fromBoolean($scope.personalProfileForm.usCitizen) || 0;
                request.taxCountry = ($scope.personalProfileForm.taxCountry && $scope.personalProfileForm.taxCountry.code) || '';
                request.nationalId = $scope.personalProfileForm.nationalId || '';
                request.companyName = $scope.personalProfileForm.companyName || '';
                request.married = Utils.fromBoolean($scope.personalProfileForm.isMarried) || 0;
                request.spouseAware = Utils.fromBoolean($scope.personalProfileForm.isSpouse) || 0;
                request.birthPlace = $scope.personalProfileForm.birthPlace || '';
                request.is_pep = Utils.fromBoolean($scope.personalProfileForm.pep) || 0;
                request.tin_absence_reason = $scope.personalProfileForm.tinAbsenceReason || '';
            }
            if ($scope.profileRulesHelper.isVisible('tradingExperience')) {
                request.tradingExperience = Utils.fromBoolean($scope.personalProfileForm.tradingExperience) || 0
            }

            if ($scope.personalProfileForm.customFields && Object.keys($scope.personalProfileForm.customFields).length) {
                // map custom fields to db fields
                var customFieldsFromCountry = $scope.personalProfileForm.country.customFields;

                var customFields = Object.keys($scope.personalProfileForm.customFields)
                    .reduce(function (acc, field) {
                        var customField = _.find(customFieldsFromCountry, {mapTo: field});
                        if (customField) {
                            //rewrite field name by field from country custom field
                            acc[customField.field] = $scope.personalProfileForm.customFields[field];
                        } else {
                            //leave field name as is
                            acc[field] = $scope.personalProfileForm.customFields[field];
                        }
                        return acc;
                    }, {});
                request = Object.assign({}, request, customFields);
            }

            function updateProfile(response) {
                var isLive = true;
                $scope.user.updatePersonalDetails(Object.assign({}, request, response));
                $scope.user.registrationState = response.registrationState;

                if ($scope.isRegulated && $scope.user.registrationState < 3) {
                    $ionicLoading.hide();
                    //redirect to questionarrie
                    return $state.go('signupQuestionnaire', {cache: false});
                }

                return AccountService.createAccount(isLive)
                    .then(Utils.wait(2000))
                    .then(function (response) {
                        return AccountService.switchAccount(response.mt4Account.login, isLive)
                    })
                    .then(function () {
                        // create additional demo account
                        return Const['demoAccountCreateWithLive'] && AccountService.createAccount(false)
                    })
                    .then(function () {
                        $ionicLoading.hide();

                        if ($scope.autoUpdatePersonalDetails) {
                            $state.go('root.app.assets', {cache: false});
                        } else {
                            $state.go('root.app.wallet', {cache: false});
                        }
                    })
            }

            function updateTerms(response) {
                if (!$scope.personalProfileForm.terms) {
                    return response;
                }

                return API.acceptTnc()
                    .then(function () {
                        return response
                    });
            }

            Onesignal.setTag("currency", request.currency);

            $ionicLoading.show({templateUrl: 'templates/directives/message-spinner.html', scope: $scope});
            return API.personalDetails(request)
                .then(checkResponse)
                .then(updateTerms)
                .then(function (response) {
                    return updateProfile(response);
                })
                .catch(function (error) {
                    $ionicLoading.hide();

                    //block countries
                    if (error.code == "3040") {
                        throw error;
                    }

                    $scope.modal.isError = true;
                    $scope.modal.textTitle = (error && LocaleService.translation.messages[error.code]) || LocaleService.translation.messages.general_error;
                    $scope.modal.textContent = "";

                    if (error.code == "3043" || error.code == "3044") {
                        $scope.modal.textTitle = LocaleService.translation.messages["3040"]; // "registration blocked" title
                        $scope.modal.textContent = (error && LocaleService.translation.messages[error.code]) || "";
                        $scope.modal.actionText = LocaleService.translation.logout;
                        $scope.modal.back = function () {
                            $ionicLoading.show();
                            return LoginService.logout()
                                .then(function () {
                                    $ionicLoading.hide();
                                    return $state.go('welcome', {cache: false});
                                })
                        }
                    }

                    $scope.modal.state = true;
                })
        }

        function submitPersonalDetailsSplit() {
            var request = {
                firstName: $scope.user.firstName,
                lastName: $scope.user.lastName,
                birthday: $scope.user.birthday,
                country: $scope.user.country,
                state: $scope.user.state,
                city: $scope.user.city,
                address: $scope.user.address,
                currency: $scope.user.currency,
                postCode: $scope.user.postCode,
                citizenship: $scope.user.citizenship,
                usTaxId: $scope.user.usTaxId,
                customerType: $scope.user.customerType || '',
                phone: $scope.user.phone,

                tin: $scope.personalProfileForm.tin,
                usCitizen: Utils.fromBoolean($scope.personalProfileForm.usCitizen) || 0,
                taxCountry: ($scope.personalProfileForm.taxCountry && $scope.personalProfileForm.taxCountry.code) || '',
                nationalId: $scope.personalProfileForm.nationalId || '',
                companyName: $scope.personalProfileForm.companyName || '',
                married: Utils.fromBoolean($scope.personalProfileForm.isMarried) || 0,
                spouseAware: Utils.fromBoolean($scope.personalProfileForm.isSpouse) || 0,
                birthPlace: $scope.personalProfileForm.birthPlace || '',
                gender: $scope.personalProfileForm.gender || 1
            };
            console.log(request);
            $ionicLoading.show({templateUrl: 'templates/directives/message-spinner.html', scope: $scope});

            return API.updatePersonalDetails(request)
                .then(checkResponse)
                .then(function (response) {
                    $ionicLoading.hide();

                    $scope.user.tin = request.tin;
                    $scope.user.nationalId = request.nationalId;
                    $scope.user.birthPlace = request.birthPlace;
                    $scope.user.taxCountry = request.taxCountry;
                    $scope.user.gender = request.gender;

                    if (['FSA', 'FSCA'].includes($scope.user.regulation)) {
                        return $state.go('signupQuestionnaire', {cache: false});
                    }

                    return $state.go('root.app.verification-v2', {cache: false});

                })
                .catch(function (error) {
                    $ionicLoading.hide();

                    $scope.modal.isError = true;
                    $scope.modal.textTitle = (error && LocaleService.translation.messages[error.code]) || LocaleService.translation.messages.general_error;
                    $scope.modal.textContent = "";
                    $scope.modal.state = true;
                })


        }

        $scope.updatePersonalDetails = function (form) {

            Utils.formRevalidate(form, true);

            if (!form.$valid) return;

            // follow cmtrading registration flow
            if ($scope.isRegulated && Const['splitPersonalDetails']) {
                switch ($scope.pageState) {
                    case 0:
                        return submitPersonalDetails()
                    case 1:
                        return submitPersonalDetailsSplit()
                }
            }

            if ($scope.isRegulated && $scope.pageState === 0 && !$scope.constants['disablePersonalDetailsStep2']) {
                $scope.pageState = 1; //switch to regulated personal profile additions
                return;
            }

            return submitPersonalDetails();
        };

        $scope.switchDemoAccount = function () {
            var isLive = false;
            var currency = Utils.getCurrencyByCountry($scope.user.country, $scope.countries, $scope.currencyList);

            //if we are already logged in demo - simple redirect to assets
            if ($scope.user.activeTradingAccount && !$scope.user.activeTradingAccount.live) {
                $ionicLoading.hide();
                return $state.go('root.app.assets');
            }

            $ionicLoading.show();

            var demoAccount = _.find($scope.user.tradingAccounts, {live: false});
            if (demoAccount) {
                return AccountService.switchAccount(demoAccount.login, false)
                    .then(function () {
                        $ionicLoading.hide();
                        return $state.go('root.app.assets');
                    })
                    .catch(function (error) {
                        $ionicLoading.hide();
                        $scope.modal.isError = true;
                        $scope.modal.textTitle = (error && LocaleService.translation.messages[error.code]) || LocaleService.translation.messages.general_error;
                        $scope.modal.textContent = "";
                        $scope.modal.state = true;
                    });
            }

            return AccountService.createAccount(isLive, currency)
                .then(function (response) {
                    return AccountService.switchAccount(response.mt4Account.login, isLive)
                })
                .then(function () {
                    $ionicLoading.hide();
                    return $state.go('root.app.assets');
                })
                .catch(function (error) {
                    $ionicLoading.hide();
                    $scope.modal.isError = true;
                    $scope.modal.textTitle = (error && LocaleService.translation.messages[error.code]) || LocaleService.translation.messages.general_error;
                    $scope.modal.textContent = "";
                    $scope.modal.state = true;
                })
        };

        $scope.showInfo = function (field) {
            ionicToast.show($scope.translation[field + 'PopoverContent'], 'top', false, 15000, '');
        }

        $scope.$on('$ionicView.afterLeave', function (event) {
            $scope.countryModal && $scope.countryModal.hide() && $scope.countryModal.remove();
        });

        // switch to regulated page
        // follow cmtrading registration flow
        if (Const['splitPersonalDetails']) {
            if ($scope.user.registrationState === 3 && !$scope.user.taxCountry.length) {
                $scope.pageState = 1;
            }
        }
    }]);
